const React = require('react');
const ThumborContext = require('./context/thumbor-context');

/**
 * Wraps the root element with the ThumborContext provider. This provider is used to pass down
 * the plugin options configured in gatsby-config.js.
 */
exports.default = ({ element }, pluginOptions) => {
	// Sanitize the pluginOptions so we don't accidentally leak sensitive information.
	const options = {
		breakpoints: pluginOptions.breakpoints,
	};

	return <ThumborContext.Provider value={{ options }}>{element}</ThumborContext.Provider>;
};
